/**
 * Textos e regras das confirmações da premiação — puros, testados em `tests/premiacao-confirmacoes`.
 * Pagar e ligar pessoa mexem em dinheiro: nada disso acontece num clique só.
 */

/**
 * Por que o pagamento está desligado (null = pode pagar). O servidor é quem recusa
 * (`pagarSemana`); a tela só explica, com o MESMO motivo que ele mandou em `leituraPendente`.
 */
export function porQueNaoPaga(x: {
  readonly fechada: boolean;
  readonly leituraPendente?: string | null;
}): string | null {
  if (!x.fechada) return 'A semana só pode ser paga depois do último dia dela (sexta-feira).';
  return x.leituraPendente ?? null;
}

/** A pergunta antes de ligar um nome do HOS a uma pessoa (ou tirá-lo da conta). */
export function perguntaDaPonte(nomeHos: string, pessoa: string | null): string {
  return pessoa
    ? `Ligar ${nomeHos} a ${pessoa}?`
    : `Tirar ${nomeHos} da conta? As vendas desse nome não pagam ninguém.`;
}

/** O que a tela diz depois de ligar — com o Desfazer ao lado. */
export function feitoNaPonte(nomeHos: string, pessoa: string | null): string {
  return pessoa ? `${nomeHos} ligado a ${pessoa}.` : `${nomeHos} fora da conta: não é balconista.`;
}

/**
 * O desfecho de "Liberar" quando a linha junta VÁRIAS vendas (um POST por venda). Nunca some
 * com o que já foi liberado: diz "X de N liberadas" e a tela recarrega mesmo quando uma falha.
 * `null` = todas liberadas.
 */
export function resumoDaLiberacao(liberadas: number, total: number, falha: string): string | null {
  if (liberadas >= total) return null;
  const n = `${String(liberadas)} de ${String(total)}`;
  return `${n} ${total === 1 ? 'liberada' : 'liberadas'}. ${falha}`;
}
